import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import ConsentController from "@source/api/controllers/consentController";
import {ConsentCategory, ConsentCategoryStatus} from "@source/api/models/consentModels";
import {ConsentRequestState} from "@source/components/consentDocuments";
import {HOME_ROUTES} from "@source/utils/utils";
import {CategoryForm} from "../consentCategories/categoryForm";

export const CategoryDetail = ({organizationId, canManage, canReadTemplates}: {organizationId: string; canManage: boolean; canReadTemplates: boolean}) => {
  const history = useHistory();
  const {categoryId} = useParams<{categoryId: string}>();
  const [category, setCategory] = useState<ConsentCategory | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const load = async () => { setLoading(true); setError(""); try { setCategory(await ConsentController.getCategory(organizationId, categoryId)); } catch (requestError: unknown) { setError(requestError instanceof Error ? requestError.message : "Unable to load the Consent Category."); } finally { setLoading(false); } };
  useEffect(() => { load(); }, [organizationId, categoryId]);
  if (loading) return <ConsentRequestState variant="loading" title="Loading Consent Category"/>;
  if (error || !category) return <ConsentRequestState variant="error" title="Unable to load Consent Category" description={error} onRetry={load}/>;
  return <CategoryForm organizationId={organizationId} canReadTemplates={canReadTemplates} category={category} canEdit={canManage && category.status === ConsentCategoryStatus.ACTIVE} onSaved={() => history.push(HOME_ROUTES.ConsentDocumentsCategories)}/>;
};

